import React, { useContext, useCallback } from 'react';
import { VideosContext, IVideosContext } from '../../videosState/videosContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import PreviewModal from './PreviewModal/PreviewModal';

export const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, setIDForFullInfo, typeOfModalWindow, IDForFullInfo } =
		useContext<IVideosContext>(VideosContext);

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	const handleCloseVideoModal = () => {
		setIDForFullInfo(null);
	};

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow || !!IDForFullInfo}>
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteVideo"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteVideoSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingVideo"
			/>
			<PreviewModal isVisible={!!IDForFullInfo} IDForFullInfo={IDForFullInfo} onClose={handleCloseVideoModal} />
		</ModalWrapper>
	);
};
